export default __webpack_public_path__ + "static/media/foliage.f503befb.png";